module.exports = __webpack_public_path__ + "static/media/truck.a829f9cf.svg";